import { cn } from '@/lib/utils';

// ─── StatTile ─────────────────────────────────────────────────────────────────

export interface StatTileProps {
  label: string;
  value: string | number;
  variant?: 'default' | 'success' | 'destructive' | 'warning';
}

export function StatTile({ label, value, variant = 'default' }: StatTileProps) {
  const colorMap: Record<NonNullable<StatTileProps['variant']>, string> = {
    default: 'text-foreground',
    success: 'text-success',
    destructive: 'text-destructive',
    warning: 'text-warning',
  };
  return (
    <div className="flex flex-col items-center rounded-md border border-border bg-muted/30 p-3">
      <span className={cn('text-xl font-bold', colorMap[variant])}>{value}</span>
      <span className="text-xs text-muted-foreground">{label}</span>
    </div>
  );
}
